import CommunityCentricBlock from './CommunityCentricBlock'
import IconFeaturedBlock from './IconFeaturedBlock'

export { CommunityCentricBlock, IconFeaturedBlock }
